<div style="padding: 12px;">
  <h3 mat-dialog-title>{{data.messageTitle}}</h3>
  <mat-dialog-content class="mat-typography">
  <h6 class="mat-body-1">{{ data.message }}</h6>
  </mat-dialog-content>
  <div mat-dialog-actions>
    <button shape="semi-round" hero status="info" fullWidth nbButton mat-dialog-close>ok</button>
  </div>
</div>
